import { ExternalImage } from '../Components/ExternalContent';
import React from "react";
import { Building2, Globe, Video, Mail } from "lucide-react";
import "./platformHome.css";
import "./ottieni.css";

const CONTACT_EMAIL = "info@ceformedsrl.it";
const iconProps = { size: 24, strokeWidth: 1.75, "aria-hidden": true };

const IMAGES = {
  team:
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1400&q=80",
  office:
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80",
};

const Ottieni = () => (
  <div className="showcase ottieni">
    <section className="ottieni-hero ottieni-hero--split">
      <div>
        <p className="showcase-kicker">Richiesta di attivazione</p>
        <h1>
          WebinarPlus è riservato agli enti
          <span>che ne fanno richiesta.</span>
        </h1>
        <p className="ottieni-lead">
          La piattaforma non è disponibile in modalità autonoma. Per ottenerla è
          necessario rivolgersi a CeForMed srl, che valuta la richiesta e attiva
          un gestionale dedicato, con sito pubblico, calendario eventi e sala
          di diretta.
        </p>
      </div>
      <ExternalImage
        className="ottieni-hero__photo"
        src={IMAGES.team}
        alt="Team al lavoro durante una riunione di progetto"
      />
    </section>

    <section className="showcase-band ottieni-band">
      <div className="showcase-band__inner showcase-band__inner--split">
        <div>
          <h2>Un&apos;istanza per ciascun ente</h2>
          <p>
            Ogni organizzazione riceve un indirizzo proprio, i colori e i contenuti
            istituzionali, e gli account di amministrazione e gestione. L&apos;attivazione
            avviene esclusivamente a seguito di contatto, in modo da definire
            perimetro, responsabilità e tempi di avvio.
          </p>
        </div>
        <ExternalImage
          className="showcase-band__photo"
          src={IMAGES.office}
          alt="Spazio di lavoro di un ente"
        />
      </div>
    </section>

    <section className="ottieni-body">
      <h2>Cosa viene messo a disposizione</h2>
      <ul className="ottieni-list">
        <li>
          <span className="ottieni-list__icon">
            <Globe {...iconProps} />
          </span>
          <div>
            <strong>Sito dell&apos;ente</strong>
            Logo, titoli, colori di navigazione e footer, recapiti e canali
            istituzionali, visibili al pubblico senza accesso.
          </div>
        </li>
        <li>
          <span className="ottieni-list__icon">
            <Building2 {...iconProps} />
          </span>
          <div>
            <strong>Gestione degli eventi</strong>
            Il gestore programma webinar con copertina, descrizione, data, ora
            (fuso di Roma) e collegamento alla diretta.
          </div>
        </li>
        <li>
          <span className="ottieni-list__icon">
            <Video {...iconProps} />
          </span>
          <div>
            <strong>Fruizione in diretta</strong>
            I partecipanti, una volta registrati, accedono alla sala: video e
            sondaggi, previa conferma di partecipazione.
          </div>
        </li>
      </ul>

      <h2>Come procedere</h2>
      <p className="ottieni-copy">
        Si prega di inviare una comunicazione all&apos;indirizzo indicato, precisando
        la denominazione dell&apos;ente, il referente e, se già noti, il numero
        approssimativo di eventi e di utenti. Un incaricato di CeForMed srl
        risponderà per illustrare i passi successivi e i tempi di attivazione.
      </p>
    </section>

    <section className="ottieni-close">
      <h2>Contatti per l&apos;attivazione</h2>
      <p>
        Per ottenere WebinarPlus è necessario scrivere a{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
      <a className="showcase-btn showcase-btn--primary" href={`mailto:${CONTACT_EMAIL}`}>
        <Mail size={18} strokeWidth={1.75} aria-hidden="true" />
        Invia una richiesta
      </a>
    </section>
  </div>
);

export default Ottieni;
